export default "/images/vendor/flag-icons/flags/1x1/cf.svg?e2e89fb8727d254107da03293f216694";